import React from 'react';
import './PageLoader.css';

const PageLoader = ({ loading, error, children }) => {
  if (loading) {
    return (
      <div className="page-loader">
        <div className="loader-spinner"></div>
        <p>Loading data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-error">
        <div className="error-icon">⚠️</div>
        <h3>Error loading data</h3>
        <pre className="error-details">{error}</pre>
        <p className="error-hint">Check browser console (F12) and server logs for details</p>
      </div>
    );
  }

  return children;
};

export default PageLoader;

